class Delete_Group {
    static path = 'group-actions/delete-group';

    constructor(mutator){
        this.title = 'Delete Group';
        this.addInput("Determining Condition", "boolean");
        this.addInput("User", "user,user_id");
        this.addInput("Group", "group,group_id");
        this.bgcolor = '#dea059';
        this.desc = 'Delete an existing group.';
    }
}

module.exports = Delete_Group
